<template>
  <div class="anypaySearch">
    <div class="topHeader clear">
      <header class="mint-header is-fixed"
              style="background-color: rgb(57, 60, 65);">
        <div class="mint-header-button is-left"
             @click="geturl">
          <i class="mintui mintui-back"></i>
        </div>
        <h1 class="mint-header-title">{{$t('anypaySearch_title')}}</h1>
        <div class="mint-header-button is-right">
          <i class="iconfont icon-menu1"
             @click="sheetVisible=true"
             slot="right"> </i>
          <actionsheet :actions="actions"
                       v-model="sheetVisible" :cancelText="$t('cancel')"></actionsheet>
        </div>
      </header>
    </div>
    <div class="dateAll">
      <div class="dataBox">
        <div class="data">
          <datepik @change='dateChange'
                   style="margin:0 auto;float:none;"
                   limit="pre"
                   step="1"></datepik>
        </div>
        <div class="line"></div>
        <div class="allBox">
          {{$t('sum')}}{{info.masterTotal}}{{$t('bi')}}，¥{{info.masterAmont |tofixed }}
        </div>
      </div>
      <div class="searchBox">
        <div class="search">
          <!-- <input class="tableNuber" type="text" name="" id="" placeholder="费用类型" v-model='searchOption.tableNo'> -->
          <span class="category "
                v-bind:class="{ active: listVisible }"
                @click='toggleList'>
            {{paySubListSelect.descript}}
            <i class="iconfont icon-xia"></i>
          </span>

          <input class="orderNumer"
                 type="text"
                 name=""
                 id=""
                 :placeholder="$t('anypaySearch_orderNumer_placeholder')"
                 v-model='searchOption.taNo'>
          <div class="searchResult"
               @click='search'>{{$t('search')}}
          </div>
        </div>
      </div>
    </div>

    <div class="category-list clear"
         v-if="listVisible">
      <div class="category-tabs">
        <ul>
          <li v-for="(item ,index) in payList"
              :key="item.code"
              :name=" item.code"
              v-bind:class="{ active: (item.code== payListActive) }"
              @click="changeFirstPayCode(index)"> <span>{{item.descript}}</span></li>
          <li class="all"
              v-bind:class="{ active: (payListActive=='0' ) }"
              @click="changeFirstPayCode('all')"><span>{{$t('all')}}</span></li>
        </ul>
      </div>
      <div class="category-content">
        <ul>
          <li v-for="(item ,index) in paySubList"
              :key="item.code"
              :name=" item.code"
              v-bind:class="{ active: (item.code== paySubListActive) }"
              @click="changeSubPayCode(index)"><span>{{item.descript}} </span></li>
        </ul>
      </div>
    </div>

    <div class="scrollBox"
         v-infinite-scroll="loadMore"
         infinite-scroll-disabled="loading"
         infinite-scroll-distance="10"
         v-else>
      <div class="orderList"
           v-for='item in listInfo'
           :key='item.index'
           @click='openDetail(item)'>
        <div class="blueLind"></div>
        <div class="infoL">
          <div class="lineInfo">
            <div class="titleThird nomalL">{{$t('anyrefundList_id')}}</div>&nbsp;:
            <span>{{item.id}}</span>
          </div>
          <div class="lineInfo">
            <div class="titleThird nomalL">{{$t('anyrefundList_feeName')}}</div>&nbsp;:
            <span>{{item.feeName}}</span>
          </div>
          <div class="lineInfo">
            <div class="titleThird nomalL">{{$t('anyrefundList_totalMoney')}}</div>&nbsp;:
            <span>{{item.totalMoney}}</span>
          </div>
          <div class="lineInfo">
            <div class="titleThird nomalL">{{$t('anyrefundList_createDate')}}</div>&nbsp;:
            <span>{{item.createDate | fd}}</span>
          </div>
        </div>
        <div class="infoL infoR">
          <div class="lineInfo">
            <div class="titleThird nomalL">{{$t('anyrefundList_taNo')}}</div>&nbsp;:
            <span>{{item.taNo | fitOrderNo}}</span>
          </div>
          <div class="lineInfo">
            <div class="titleThird nomalL">{{$t('anyrefundList_taWay')}}</div>&nbsp;:
            <span>{{item.taWay | payWayf}}</span>
          </div>
          <div class="lineInfo">
            <div class="titleThird nomalL">{{$t('anyrefundList_payMoney')}}</div>&nbsp;:
            <span>{{item.payMoney}}</span>
          </div>
          <div class="lineInfo">
            <div class="titleThird nomalL">{{$t('anyrefundList_status')}}</div>&nbsp;:
            <span>{{item.status}}</span>
          </div>
        </div>
        <i class="mintui mintui-back"></i>
      </div>
      <div v-bind:class="{ 'hide': !isEmpty }">
        <img class="nothing"
             src="../../../assets/images/nothing.png">
        <p class="nothingTxt">{{$t('anyrefundList_nothing')}}</p>
      </div>
      <div class="infoWarn"
           v-if='cutOff==1'>{{$t('loading_end_message')}}</div>
    </div>

    <mt-popup v-model="popupVisible"
              position="right"
              modal='false'>
      <div class="topHeader">
        <header class="mint-header is-fixed"
                style="background-color:rgb(57, 60, 65);">
          <div class="mint-header-button is-left">
            <a class="router-link-exact-active router-link-active"
               @click='openDetail'>
              <i class="mintui mintui-back"
                 style="font-size:0.64rem"></i>
            </a>
          </div>
          <h1 class="mint-header-title">{{$t('anyrefundList_order_detail')}}</h1>
          <div class="mint-header-button is-right">
          </div>
        </header>
      </div>
      <anypayMasterList ref="masterListC"></anypayMasterList>
    </mt-popup>
  </div>
</template>
<script>
import datepik from "../../common/datepik";
import anypayMasterList from "../../common/anypayMasterList";
import moment from "moment";
import { InfiniteScroll, Actionsheet, Toast } from "mint-ui";
import { payWay } from "../../../assets/js/anypay";

export default {
  data() {
    return {
      listVisible: false,
      payList: [],
      payListActive: "",
      payCode: "",
      paySubList: [],
      paySubListActive: "",
      paySubListSelect: {
        descript: "全部"
      },
      accnt: "",
      select_time: "",
      cutOff: "",
      isEmpty: true,
      info: {
        masterAmont: 0,
        masterTotal: 0
      },
      orderInfoObj: "",
      popupVisible: false,
      listInfo: [],
      searchOption: {
        createDate: "",
        taNo: "",
        feeCode: "",
        //currentPage: 1,
        pageSize: 10,
        pageIndex: 1
      },
      sheetVisible: false,
      actions: [],
      rights: []
    };
  },
  computed: {},
  mounted() {
    this.actions = [];
    this.actions.push({
      name: this.$t("anyrefundList_action_anpay"),
      method: () => {
        this.$router.push("/anypay/anypay");
      }
    });
    this.actions.push({
      name: this.$t("anypay_action_goRefund"),
      method: this.goRefund
    });
    this.init();
    this.getInfo();
  },
  filters: {
    tofixed(v) {
      return parseFloat(v).toFixed(2);
    },
    fd(value) {
      if (value == null || value == "") return "";
      return value.substr(11);
    },
    fitOrderNo(v) {
      return v != null && v.indexOf("_") > 0 ? v.split("_")[0] : v;
    },
    payWayf(v) {
      return payWay(v);
    }
  },
  methods: {
    geturl() {
      return this.$router.push(this.$route.query.redirect || '/anypay/anypay');
    },
    goRefund() {
      if (this.rights.indexOf("wap!anypay!refund") < 0) {
        this.msg(this.$t("msg_goRefund"));

        this.sheetVisible = false;
      } else {
        this.$router.push("/anypay/RefundList");
      }
    },
    toggleList() {
      this.listVisible = !this.listVisible;
    },
    getCategoryList() {
      this.$http.post("/mobilepmsapi/pay/getPayAccount").then(res => {
        if (res.data.result == 0) {
          var result = res.data.retVal;
          this.payList = result.pay;
          this.rights = result.rights;
          this.payCode = result.payCode;
          if (JSON.stringify(this.payList[0]) != "{}") {
            this.paySubList = result.pay[0].list;
            this.payListActive = result.pay[0].code;
          }
        } else {
          this.msg(res.data.msg);
        }
      });
    },
    changeFirstPayCode(index) {
      if (index == "all") {
        this.paySubList = [];
        this.payListActive = "0";
        this.paySubListSelect = {
          descript: this.$t("all")
        };
        this.paySubListActive = "";
        this.listVisible = false;
        this.searchOption.feeCode = "";
        this.search();
      } else {
        this.paySubList = this.payList[index].list;
        this.payListActive = this.payList[index].code;
      }
    },
    changeSubPayCode(index) {
      this.paySubListActive = this.paySubList[index].code;
      this.paySubListSelect = this.paySubList[index];
      this.searchOption.feeCode = this.paySubListActive;
      this.listVisible = false;
      this.search();
    },
    init() {
      this.getCategoryList();
    },
    notsees() {
      this.popupVisible = false;
    },
    search() {
      //查询的时候充值分页
      this.searchOption.pageIndex = 1;
      this.getInfo();
    },
    dateChange(value) {
      //console.log("dateChange")
      this.searchOption.createDate = moment(value).format("YYYY-MM-DD");
      this.listInfo = [];
      this.getInfo();
    },
    openDetail(item) {
      this.popupVisible = !this.popupVisible;

      this.$refs.masterListC.getMasterList(item.id);
      //this.popupVisible=!this.popupVisible
    },
    getInfo(isloadMore) {
      this.searchOption.feeCode = this.paySubListActive;

      this.cutOff = 0;
      this.$http
        .post("/mobilepmsapi/pay/findPageList", this.searchOption)
        .then(res => {
          if (res.data.result == 0) {
            this.info.masterAmont = res.data.retVal.totalMoney;
            this.info.masterTotal = res.data.retVal.totalCount;
            this.isEmpty = false;
            if (isloadMore) {
              // 加载更多
              _.forEach(res.data.retVal.list, (el, key) => {
                this.listInfo.push(el);
              });
            } else {
              // 第一次加载数据
              this.listInfo = res.data.retVal.list;
            }
            //判断是否已经到底了的

            if (
              this.info.masterTotal >= 4 &&
              this.info.masterTotal <
                this.searchOption.pageSize * this.searchOption.pageIndex
            ) {
              this.cutOff = 1;
              console.log("cutoff");
            }

            this.loading = false;
            if (this.info.masterTotal == "0") {
              //this.msg('查询结果为0笔')
              this.isEmpty = true;
              this.cutOff = 0;
            }
          } else {
            this.msg(res.data.msg);
          }
        });
    },
    msg(msg) {
      Toast({
        message: msg,
        position: "bottom",
        duration: 3000
      });
    },
    loadMore() {
      // 自动加载内容
      //console.log("loadMore")
      if (
        this.info.masterTotal >=
        parseInt(this.searchOption.pageSize) *
          parseInt(this.searchOption.pageIndex)
      ) {
        this.searchOption.pageIndex += 1;
        this.loading = true;
        let sef = this;
        var isloadMore = true;
        sef.getInfo(isloadMore);
      }
    }
  },
  components: {
    anypayMasterList,
    actionsheet: Actionsheet,
    datepik
  }
};
</script>

<style lang="less">
.anypaySearch {
  text-align: center;
  .topHeader {
    height: 40px;
    .mintui-back {
      font-size: 0.64rem;
    }
    .icon-menu1 {
      font-size: 0.5rem;
      padding: 0.3rem 0.1rem;
    }
  }
  .topHeader .mint-header {
    color: #fff;
    font-size: 16px;
    z-index: 100;
  }
  .category-list {
    position: absolute;
    height: auto;
    top: 3.6rem;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 0 8px 10px 8px;
    padding: 13px 0;
    background: #ffffff;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    z-index: 100;
    .category-tabs {
      width: 33.33%;
      float: left;
      display: inline-block;
      height: 100%;
      border-right: 1px solid #eeeeee;
    }
    .category-tabs ul {
      height: 100%;
      overflow: auto;
      position: relative;
    }
    .category-tabs ul li {
      height: 14.28%;
      position: relative;
      vertical-align: middle;
    }
    .category-tabs ul li.active {
      background: #d8af68;
      color: #fff;
    }
    .category-tabs ul li.all {
      position: absolute;
      bottom: 0;
      width: 100%;
    }

    .category-tabs ul li.active span {
      color: #fff;
    }
    .category-tabs ul li span {
      display: inline-block;
      width: 100%;
      height: 100%;
      font-size: 14px;
      color: #999999;
      line-height: 67px;
      vertical-align: middle;
    }
    .category-content {
      width: 66%;
      float: right;
      display: inline-block;
      height: 100%;
    }
    .category-content ul {
      height: 100%;
      padding: 0 30px;
      overflow: auto;
    }
    .category-content ul li {
      height: 14.28%;
      position: relative;
      vertical-align: middle;
    }
    .category-content ul li.active span {
      color: #d8af68;
    }

    .category-content ul li:before {
      content: " ";
      position: absolute;
      left: 0;
      bottom: 0;
      right: 0;
      height: 1px;
      border-bottom: 1px solid #d9d9d9;
      color: #eeeeee;
      -webkit-transform-origin: 0 0;
      transform-origin: 0 0;
      -webkit-transform: scaleY(0.5);
      transform: scaleY(0.5);
    }
    .category-content ul li span {
      font-size: 14px;
      color: #000000;
      line-height: 67px;
    }
  }

  overflow-y: hidden;
  .dateAll {
    width: 100%;
    height: 2.88rem;
    background: #fff;
    position: fixed;
    margin-top: -1px;
    z-index: 2000;
    .dataBox {
      margin: 0 auto;
      width: 96%;
      height: 100%;
      .data {
        width: 59%;
        height: 1.0667rem;
        margin-top: 0.1067rem;
        display: inline-block;
        .iconBox {
          border-radius: 2.6667rem;
          width: 0.8533rem;
          height: 0.8533rem;
          display: inline-block;
          text-align: center;
          background: #fff;
          -moz-transform: none;
          -webkit-transform: none;
          -o-transform: none;
          -ms-transform: none;
          transform: none;
          .icon-jiantou,
          .icon-caret-right-copy {
            font-size: 0.32rem;
            line-height: 0.88rem;
            color: #d8d8d8;
            transform: scale(0.7);
          }
        }
        .blakBg {
          background: #f6f8f9 !important;
          border-radius: 2.6667rem;
        }
        .fontBlack {
          color: black !important;
        }
        .dataDtail {
          display: inline-block;
          font-size: 0.3733rem;
          color: #393c41;
          margin: 0.2667rem 0.3733rem 0rem;
        }
      }
      .line {
        width: 0.0267rem;
        text-align: center;
        display: inline-block;
        vertical-align: top;
        margin-top: 0.3733rem;
        height: 0.5867rem;
        background: #cccccc;
      }
      .allBox {
        width: 38%;
        margin-top: 0.48rem;
        height: 1.0667rem;
        display: inline-block;
        color: #393c41;
        font-size: 0.32rem;
        vertical-align: top;
      }
    }
    .searchBox {
      height: 1.6rem;
      margin: 0 auto;
      width: 100%;
      position: fixed;
      background: #f4f5f7;
      margin-top: -1px;
      top: 2.3733rem;
      .search {
        width: 94%;
        margin: 0 auto;
        height: 0.8rem;
        padding-top: 0.4rem;
        .category {
          float: left;
          display: inline-block;
          height: 0.7733rem;
          font-size: 0.3733rem;
          margin-top: 0.2rem;
          padding-left: 0.2667rem;
        }
        .tableNuber {
          width: 21%;
          height: 0.7733rem;
          font-size: 0.3733rem;
          padding-left: 0.2667rem;
          background: #fff;
          border: 0.0267rem solid #cccccc;
          border-radius: 0.1333rem;
          margin-left: 0.1333rem;
          float: left;
        }
        .orderNumer {
          width: 41%;
          height: 0.7733rem;
          font-size: 0.3733rem;
          padding-left: 0.2667rem;
          background: #fff;
          border: 0.0267rem solid #cccccc;
          border-radius: 0.1333rem;
          float: left;
          margin-left: 0.2667rem;
        }
        .searchResult {
          width: 20.5%;
          height: 0.7733rem;
          font-size: 0.3733rem;
          background: #d8af68;
          border-radius: 0.1867rem;
          float: right;
          color: #fff;
          line-height: 0.7467rem;
          margin-right: 0.08rem;
          margin-top: 0.0533rem;
        }
      }
    }
  }
  .scrollBox {
    position: fixed;
    margin-top: 2.9rem;
    width: 100%;
    height: 79%;
    overflow-y: auto;
    padding-bottom: 2rem;
    .orderList {
      background: #ffffff;
      margin-bottom: 0.2667rem;
      width: 96%;
      height: auto;
      padding-bottom: 0.2667rem;
      margin: 0 auto 0.2667rem;
      box-shadow: 0 0 0.2133rem 0rem #dadada;
      border-radius: 0.1333rem;
      position: relative;
      .mintui {
        position: absolute;
        top: 30%;
        right: 5%;
        transform: rotate(180deg);
      }
      .blueLind {
        height: 0.3733rem;
        width: 1.1%;
        background: #646f83;
        display: inline-block;
        float: left;
        margin-top: 0.48rem;
      }
      .infoL {
        width: 49%;
        height: auto;
        text-align: left;
        display: inline-block;
        padding-top: 0.3733rem;
        .lineInfo {
          margin: 0.1067rem auto;
          color: #999999;
          .titleThird {
            display: inline-block;
            color: #999999;
            letter-spacing: 0.2667rem;
          }
          .titileS {
            display: inline-block;
            color: #999999;
          }
          .nomalL {
            letter-spacing: 0rem;
          }
          span {
            margin-left: 0.1333rem;
            font-size: 0.3733rem;
            color: #151515;
          }
        }
      }
      .infoR {
        width: 45%;
      }
      .infoBo {
        text-align: left;
        margin-left: 0.3733rem;
        .titleThird {
          display: inline-block;
          color: #999999;
          letter-spacing: 0.2667rem;
        }
        .titileS {
          display: inline-block;
          color: #999999;
        }
        .nomalL {
          letter-spacing: 0rem;
        }
        span {
          margin-left: 0.1333rem;
          font-size: 0.3733rem;
          color: #151515;
        }
        b {
          font-size: 0.32rem;
          color: #4990e2;
          text-decoration: underline;
          margin-left: 0.1333rem;
        }
      }
    }
  }
  .nothing {
    width: 80px;
    height: 88px;
    margin: 150px auto 0 auto;
  }

  .nothingTxt {
    text-align: center;
    font-size: 20px;
    color: #ccd1d5;
    margin-top: 20px;
  }
  .show {
    display: block;
  }
  .hide {
    display: none;
  }
  .mint-popup-right {
    width: 100%;
    height: 100%;
  }
  .infoWarn {
    height: 50px;
  }
}
</style>









// WEBPACK FOOTER //
// anypaySearch.vue?243d5538